<script lang="ts">
    import {dyData} from 'general/store';

    import s from './style.module.css';

    export let side: 'main' | 'subscribed' | 'typ' | 'sms' = 'main';
</script>

{#if $dyData.logo && $dyData.logo[side]}
    <div class={s.logo} style="margin-top: {$dyData.logo[side].marginTop}">
        <div class={s.wrapper}>
            {#each $dyData.logo[side].images as image, index}
                <img class={s.image} src={image} alt="logo-{index}" />
            {/each}
        </div>
    </div>
{/if}
